import { EURO } from "../../../Util/currency";

export default {
    title: 'De floral designs van deze week',
    disclaimer: `* De prijzen zijn exclusief ${EURO(8.10)} bezorgkosten`,
    button: 'Bekijk het hele assortiment',
};